var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInstore = function SvgInstore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 18,
    height: 18,
    rx: 1,
    stroke: "#0B3E21",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 18a1 1 0 0 1-1-1v-5.585l-1.293 1.292a1 1 0 0 1-1.32.083l-.094-.083a1 1 0 0 1-.083-1.32l.083-.094 3-3 .044-.042.068-.055.11-.071.114-.054.105-.035.149-.03L12 8l.075.003.126.017.111.03.111.044.098.052.096.067c.031.025.062.051.09.08l3 3a1 1 0 0 1-1.32 1.497l-.094-.083L13 11.415V17a1 1 0 0 1-1 1Z",
    fill: "#0B3E21"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0B3E21",
    d: "M10 2h4v4h-4z"
  })));
};
export default SvgInstore;